import React, { Component } from 'react';
import { Table, OverlayTrigger, Tooltip } from 'react-bootstrap';
import ApiService from '../../service/ApiService';
import { Link } from 'react-router-dom';

class StockGrade extends Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            symbol: this.props.symbol,
            limit: this.props.limit
        };
    }

    componentDidMount() {
        ApiService.getGrade(this.state.symbol, this.state.limit).then(result => {
            console.log('Grade', result);
            let filteredData = [];
            let length = this.state.limit === undefined ? 200 : this.state.limit;
            if (result.length > 0) {
                length = result.length < length ? result.length : length;
                for (var i = 0; i < length; i++) {
                    filteredData.push(result[i]);
                }
            }
            this.setState({ list: filteredData });
        })
            .catch((error) => {
                console.log(error);
            });
    }

    renderRow(listValue) {
        return (
            <tr key={listValue.date + listValue.newGrade + Math.random()}>
                <td>{listValue.date}</td>
                <td>{listValue.gradingCompany}</td>
                <td>{listValue.previousGrade}</td>
                <td>{listValue.newGrade}</td>
            </tr>
        )
    }

    render() {
        let tableRow;
        if (this.state.list === undefined || this.state.list.length <= 0) {
            tableRow = <tr><td></td><td>No Data</td><td></td><td></td></tr>
        } else {
            tableRow = this.state.list.map(this.renderRow.bind(this));
        }

        let header = 'Stock Grade';
        if (this.state.limit !== undefined) {
            header = <><Link to={'/stockGrade/' + this.state.symbol}>{header}</Link> <Link style={{ fontSize: "10px"}} to={'/stockGrade/' + this.state.symbol}>(More Details)</Link></>
        } else {
            header += ' - ' + this.state.symbol;
        }

        return (
            <div>
                {header}
                <Table striped bordered hover size="xs" style={{ fontSize: "10px" }}>
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Company</th>
                            <th>Previous Grade</th>
                            <th>New Grade&nbsp;&nbsp;
                                <OverlayTrigger
                                    placement="left"
                                    overlay={<Tooltip id="button-tooltip-2" style={{ wordBreak: 'break-all' }}>
                                        Hedge Funds/Big Investor grades the stock periodically based on the Company performance<br />
                                    </Tooltip>}>
                                    <i style={{ color: '#8A2BE2', fontSize: '15px' }} className={"fa fa-question-circle"}></i>
                                </OverlayTrigger>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableRow}
                    </tbody>
                </Table>
            </div>
        );
    }
}

export default StockGrade;
